<template>
  <div class="dash">
    <stats-users-by-roles
      :data="statsUsersByRoles"
      :error="errors.statsUsersByRoles"
    />
    <a-divider />
    <a-list
      class="supported-network-list"
      bordered
      item-layout="vertical"
      :data-source="mainnetNetworks"
    >
      <a-list-item
        slot="renderItem"
        slot-scope="item">
        <a-list-item-meta>
          <div slot="title">
            {{ item.name }}
          </div>
        </a-list-item-meta>

        <a-collapse
          active-key="1"
          expand-icon-position="right"
        >
          <a-collapse-panel
            key="1"
            :header="'dashboard.tokens' | globalize">
            <total-tvl
              :title="'dashboard.tokens-total' | globalize"
              :network="item"
              :tvl-type="tvlTypesAsObject.token_tvl"
            />

            <historical-tvl
              :title="'dashboard.tokens' | globalize"
              :network="item"
              :tvl-type="tvlTypesAsObject.token_tvl"
            />
          </a-collapse-panel>
        </a-collapse>

        <a-collapse
          expand-icon-position="right"
        >
          <a-collapse-panel
            key="1"
            :header="'dashboard.dotc' | globalize">
            <total-tvl
              :title="'dashboard.dotc-total' | globalize"
              :network="item"
              :tvl-type="tvlTypesAsObject.dotc_tvl"
            />

            <historical-tvl
              :title="'dashboard.dotc' | globalize"
              :network="item"
              :tvl-type="tvlTypesAsObject.dotc_tvl"
            />
          </a-collapse-panel>
        </a-collapse>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import ADivider from 'ant-design-vue/lib/divider'
import StatsUsersByRoles from '@/vue/common/stats/stats-users-by-roles'
import { tokenIconDeliver } from '@/js/token-icons'
import HistoricalTvl from '@/vue/common/stats/historical-tvl'
import TotalTvl from '@/vue/common/stats/total-tvl'
import { tvlTypesAsObject } from '@/vue/mixins/tvl.mixin'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { SessionStorageService } from '@/js/session-storage'
import { api } from '@/api'
import AList from 'ant-design-vue/lib/list'
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'

export default {
  name: 'dashboard',
  components: {
    StatsUsersByRoles,
    HistoricalTvl,
    ADivider,
    AList,
    'a-list-item': AList.Item,
    'a-list-item-meta': AList.Item.Meta,
    TotalTvl,
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
  },
  data () {
    return {
      mainnetNetworks: [],
      statsUsersByRoles: [],
      errors: {
        statsUsersByRoles: null,
        mainnetNetworks: null,
      },
      historicalTvl: [],
      historicalTvlLoading: false,
      storage: new SessionStorageService('sn'),
      tvlTypesAsObject,
    }
  },
  async created () {
    await this.getMainnetNetworks()
    await this.getStatsUsersByRoles()
    await tokenIconDeliver.loadManifest()
  },
  methods: {
    async getMainnetNetworks () {
      let response = {}

      try {
        response = await api.getWithSignature('/supported-networks')
        this.mainnetNetworks = response.data
      } catch (e) {
        this.errors.mainnetNetworks = e.message
        ErrorHandler.processWithoutFeedback(e)
      }

      return response
    },

    async getStatsUsersByRoles () {
      let response = {}
      try {
        response = await api.getWithSignature('/users/stats-by-role')
        this.statsUsersByRoles = response.data
      } catch (e) {
        this.errors.statsUsersByRoles = e.message
        ErrorHandler.processWithoutFeedback(e)
      }

      return response
    },
  },
}
</script>

<style scoped lang="scss" >
  @import '~ant-design-vue/lib/divider/style/index.css';
  @import '~ant-design-vue/lib/collapse/style/index.css';

  .dash-stat-users-by-roles {
    margin-bottom: 1em;
  }
</style>
